export default __webpack_public_path__ + "static/media/clip_2.62d23ebe.jpeg";